var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"page-title"}),_c('el-col',{attrs:{"span":14}},[_c('Categorie')],1),_c('el-col',{attrs:{"span":10}},[_c('Tags')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }